<template>
    <div class="container">
        <div class="hierarchy">
            <div class="heads">
                <div class="left">收货地址</div>
                <div class="right newAddress" @click="addressDialog = true">
                    <i class="el-icon-plus"></i>使用新地址
                </div>
            </div>
            <div class="address">
                <div class="details" v-if="currentAddress">
                    <span>{{currentAddress.contact}}</span>&nbsp;
                    <span>{{currentAddress.contactPhone}}</span>&nbsp;
                    <span>{{currentAddress.province}}{{currentAddress.city}}{{currentAddress.area}}{{currentAddress.address}}</span>
                </div>
            </div>
        </div>
        <div class="hierarchy">
            <div class="heads">
                <div class="left">收票地址</div>
                <div class="right newAddress" @click="invoiceAddressDialog = true">
                    <i class="el-icon-edit"></i>修改地址
                </div>
            </div>
            <div class="address">
                <div class="details" v-if="invoiceAddress">
                    <span>{{invoiceAddress.contact}}</span>&nbsp;
                    <span>{{invoiceAddress.contactPhone}}</span>&nbsp;
                    <span>{{invoiceAddress.province}}{{invoiceAddress.city}}{{invoiceAddress.area}}{{invoiceAddress.address}}</span>
                </div>
            </div>
        </div>
        <div class="hierarchy">
            <div class="heads">
                <div class="left">开票地址</div>
                <div class="right newAddress" @click="userInvoiceAddressDialog = true">
                    <i class="el-icon-edit"></i>修改地址
                </div>
            </div>
            <div class="address">
                <div class="details" v-if="userInvoiceAddress">
                    <p>开票类型：{{invoiceType[userInvoiceAddress.invoiceType]}}</p>
                    <p>开票抬头：{{userInvoiceAddress.invoiceTitle}}</p>
                    <p>税号：{{userInvoiceAddress.dutyNo}}</p>
                    <p>开户行：{{userInvoiceAddress.bankName}}</p>
                    <p>银行卡号：{{userInvoiceAddress.bankNo}}</p>
                    <p>开票地址：{{userInvoiceAddress.province}}{{userInvoiceAddress.city}}{{userInvoiceAddress.area}}{{userInvoiceAddress.address}}</p>
                    <p>开票电话：{{userInvoiceAddress.mobile}}</p>
                </div>
            </div>
        </div>
        <div class="hierarchy">
            <div class="heads">
                <div class="left">代金券</div>
                <div class="right newAddress" @click="couponDialog = true">
                    <i class="el-icon-plus"></i>选择代金券
                </div>
            </div>
            <div class="address">
                <div class="details" v-if="currentCoupon">
                    <span>{{currentCoupon.faceValue}}</span>
                </div>
            </div>
        </div>
        <div class="hierarchy">
            <div class="heads">
                <div class="left">支付方式</div>
            </div>
            <div class="address">
                <el-radio v-model="payParams.payWay" :label="2">线下支付</el-radio>
                <el-radio v-model="payParams.payWay" :label="1">余额支付</el-radio>
            </div>
        </div>
        <div class="hierarchy">
            <div class="heads">
                <div class="left">清单信息</div>
            </div>
            <div class="money">
                <div>
                    <span class="title">订单金额：</span>
                    <span class="num">￥{{payParams.orderAmount}}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="title">运费：</span>
                    <span class="num">￥{{payParams.waybillAmount}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span
                        class="title"
                        v-if="payParams.deductionAmount"
                    >代金券：</span>
                    <span
                        class="num"
                        v-if="payParams.deductionAmount"
                    >￥{{payParams.deductionAmount.toFixed(2)}}</span>
                </div>
            </div>

            <div>
                <table>
                    <tr class="th">
                        <td>品牌</td>
                        <td>货号</td>
                        <td>包装单位</td>
                        <td>纯度</td>
                        <td>库存</td>
                        <td>产品描述</td>
                        <td>价格</td>
                        <td>购买数量</td>
                        <td>小计</td>
                    </tr>
                    <tbody>
                        <tr v-for="(item, index) in cartList" :key="index">
                            <td>{{item.brandName}}</td>
                            <td>{{item.specsNo}}</td>
                            <td>{{item.packingUnit}}</td>
                            <td>{{item.purity}}</td>
                            <td>{{item.deliver}}</td>
                            <td>{{item.specsDesc}}</td>
                            <td>
                                <span style="color: red;">{{ item.discountMoney}}</span>
                                <span
                                    style="color: #999; text-decoration: line-through; font-size: 12px; margin-left: 5px;"
                                >{{item.originalMoney}}</span>
                            </td>
                            <td>{{item.amount}}</td>
                            <td>{{(item.amount * item.discountMoney.replace(',', '')).toFixed(2)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="orderSubmitDiv" style="margin-top:60px">
            <div class="pressbutton" @click="handleCreateOrder">确认订单</div>
            <div class="price">￥{{actualAmount.toFixed(2)}}</div>
            <div class="notin">应付总额：</div>
            <div class="am">
                商品共&nbsp;&nbsp;
                <span id="length">{{shopNum}}</span>&nbsp;&nbsp;件
            </div>
        </div>

        <el-dialog title="选择收货地址" :visible.sync="addressDialog" width="800px">
            <Address :from="'order'" ref="addressRef"></Address>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addressDialog = false">取 消</el-button>
                <el-button type="primary" @click="handleChangeAddress">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改收票地址" :visible.sync="invoiceAddressDialog" width="800px">
            <InvoinceAddress :from="'order'" ref="invoinceAddressRef"></InvoinceAddress>
            <div slot="footer" class="dialog-footer">
                <el-button @click="invoiceAddressDialog = false">取 消</el-button>
                <el-button type="primary" @click="handleChangeInvoinceAddress">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改开票地址" :visible.sync="userInvoiceAddressDialog" width="800px">
            <UserInvoice :from="'order'" ref="userInvoinceAddressRef"></UserInvoice>
            <div slot="footer" class="dialog-footer">
                <el-button @click="userInvoiceAddressDialog = false">取 消</el-button>
                <el-button type="primary" @click="handleChangeUserInvoinceAddress">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="选择代金券" :visible.sync="couponDialog" width="800px">
            <Coupon :from="'order'" :orderAmount="payParams.orderAmount" ref="couponRef"></Coupon>
            <div slot="footer" class="dialog-footer">
                <el-button @click="couponDialog = false">取 消</el-button>
                <el-button type="primary" @click="handleChangeCoupon">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as apis from '../fetch/user';
import * as apisOrder from '../fetch/order';

import Address from '../components/address/Address';
import InvoinceAddress from '../components/address/InvoiveAddress';
import UserInvoice from '../components/address/UserInvoice';
import Coupon from '../components/order/Coupon';

export default {
    name: 'order',
    components: {
        Address,
        InvoinceAddress,
        Coupon,
        UserInvoice,
    },
    computed: {
        actualAmount() {
            return (
                this.payParams.orderAmount * 1 +
                this.payParams.waybillAmount * 1 -
                this.payParams.deductionAmount
            );
        },
    },
    data() {
        return {
            cartList: [],
            shopNum: 0,
            payParams: {
                orderAmount: 0,
                payWay: 1,
                waybillAmount: 0,
                receiveAddressId: null,
                invoiceAddressId: null,
                couponRecordId: null,
                deductionAmount: 0,
                invoiceId: null,
            },
            invoiceAddress: null,
            invoiceAddressDialog: false,
            userInvoiceAddress: null,
            userInvoiceAddressDialog: false,
            addressDialog: false,
            currentAddress: null,
            couponDialog: false,
            currentCoupon: null,
            invoiceType: {
                1: '专票',
                2: '普票',
            },
        };
    },
    methods: {
        getInvoiceAddress() {
            apis.getInvoiceAddress().then(res => {
                if (res) {
                    this.invoiceAddress = res;
                    this.payParams.invoiceAddressId = res.id;
                }
            });
        },
        getUserInvoiceAddress() {
            apis.getUserInvoice().then(res => {
                if (res) {
                    this.userInvoiceAddress = res;
                    this.payParams.invoiceId = res.id;
                }
            });
        },
        getAddress() {
            apis.getDefaultAddress().then(address => {
                if (address) {
                    this.payParams.receiveAddressId = address.id;
                    this.currentAddress = address;
                }
            });
        },
        getCartList() {
            apisOrder.getCartList().then(res => {
                const ids = this.$route.query.ids.split(',');
                const cartList = ids.map(id => res.find(cart => cart.id === +id));
                const orderAmount = cartList.reduce(
                    (prve, next) => prve + next.amount * next.discountMoney.replace(',', ''),
                    0,
                );
                const shopNum = cartList.reduce((prve, next) => prve + next.amount * 1, 0);
                this.cartList = cartList;
                this.shopNum = shopNum;
                this.payParams.orderAmount = orderAmount.toFixed(2);
                this.getWayBillMoney();
            });
        },
        getWayBillMoney() {
            apisOrder.getWayBillMoney(this.payParams.orderAmount).then(res => {
                this.payParams.waybillAmount = res;
            });
        },
        handleChangeAddress() {
            const addressComponent = this.$refs['addressRef'];
            if (!addressComponent.currentAddress) {
                return;
            }
            this.payParams.receiveAddressId = addressComponent.currentAddress;
            const address = addressComponent.address.list.find(
                a => a.id === addressComponent.currentAddress,
            );
            this.currentAddress = address;
            this.addressDialog = false;
        },
        handleChangeInvoinceAddress() {
            const invoinceAddressComponent = this.$refs['invoinceAddressRef'];
            invoinceAddressComponent.$refs['form'].validate(valid => {
                if (valid) {
                    const params = {
                        ...invoinceAddressComponent.form,
                        province: invoinceAddressComponent.form.pca[0],
                        city: invoinceAddressComponent.form.pca[1],
                        area: invoinceAddressComponent.form.pca[2],
                    };
                    delete params.pca;
                    apis.setInvoiceAddress(params).then(res => {
                        this.getInvoiceAddress();
                        this.invoiceAddressDialog = false;
                    });
                }
            });
        },
        handleChangeUserInvoinceAddress() {
            const userInvoinceAddressComponent = this.$refs['userInvoinceAddressRef'];
            userInvoinceAddressComponent.$refs['form'].validate(valid => {
                if (valid) {
                    const params = {
                        ...userInvoinceAddressComponent.form,
                        province: userInvoinceAddressComponent.form.pca[0],
                        city: userInvoinceAddressComponent.form.pca[1],
                        area: userInvoinceAddressComponent.form.pca[2],
                    };
                    delete params.pca;
                    delete params.id;
                    delete params.userId;
                    apis.setUserInvoice(params).then(res => {
                        this.getUserInvoiceAddress();
                        this.userInvoiceAddressDialog = false;
                    });
                }
            });
        },
        handleChangeCoupon() {
            const couponComponent = this.$refs['couponRef'];
            if (!couponComponent.currentCoupon) {
                this.payParams.couponRecordId = null;
                this.payParams.deductionAmount = null;
                this.currentCoupon = null;
            } else {
                this.payParams.couponRecordId = couponComponent.currentCoupon;
                const coupon = couponComponent.coupons.list.find(
                    a => a.id === couponComponent.currentCoupon,
                );
                this.payParams.deductionAmount = coupon.moneyStr.replace(',', '') * 1;
                this.currentCoupon = coupon;
            }

            this.couponDialog = false;
        },
        handleCreateOrder() {
            const orderContent = this.cartList.map(item => ({
                id: item.id,
                amount: item.amount,
                money: item.discountMoney,
            }));
            const params = {
                ...this.payParams,
                actualAmount: this.actualAmount,
                orderContent: JSON.stringify(orderContent),
            };
            if (!params.couponRecordId) {
                delete params.couponRecordId;
                delete params.deductionAmount;
            }
            if (!params.invoiceAddressId) {
                this.$message.error('请先修改收票地址');
                return;
            }
            if (!params.invoiceId) {
                this.$message.error('请先修改开票地址');
                return;
            }
            if (!params.receiveAddressId) {
                this.$message.error('请先选择收获地址');
                return;
            }
            apisOrder.createOrder(params).then(res => {
                this.$message({
                    message: '下单成功',
                    type: 'success',
                });
                this.$router.push({
                    path: '/center/order',
                });
            });
        },
    },
    mounted() {
        this.getInvoiceAddress();
        this.getUserInvoiceAddress();
        this.getAddress();
        this.getCartList();
    },
};
</script>


<style scoped lang="less">
.hierarchy {
    margin-top: 30px;
}
.hierarchy .heads {
    height: 30px;
    border-bottom: 1px solid #ececec;
    font-size: 14px;
}
.hierarchy .heads .left {
    float: left;
    font-weight: 700;
}

.hierarchy .heads .right {
    float: right;
    color: #02963e;
    cursor: pointer;
    font-size: 13px;
}

.hierarchy .address {
    padding-top: 20px;
    font-size: 14px;
    margin-left: 20px;
}

.orderSubmitDiv {
    height: 70px;
}

.orderSubmitDiv .pressbutton {
    float: right;
    width: 135px;
    height: 70px;
    background: #02963e;
    text-align: center;
    line-height: 70px;
    cursor: pointer;
    color: #fff;
}

.orderSubmitDiv .price {
    float: right;
    height: 70px;
    color: red;
    font-size: 17px;
    margin-right: 25px;
    line-height: 70px;
}

.orderSubmitDiv .notin {
    width: 65px;
    float: right;
    color: #6b6b6b;
    font-size: 13px;
    line-height: 70px;
}

.orderSubmitDiv .am {
    width: 90px;
    height: 70px;
    float: right;
    color: #6b6b6b;
    font-size: 13px;
    line-height: 70px;
}
.money {
    height: 60px;
    line-height: 60px;
    font-size: 14px;
}

.num {
    color: red;
}
</style>